import {useSyncExternalStore} from 'react'

/** Recortes que el navegador no pudo cargar: GCS borra los `.png` de `bateria/` a los 30 días y la cola
 * firma sin comprobar existencia. Es de módulo porque cuatro sitios sin árbol común leen el mismo hecho. */
const caidos = new Set<string>()
const oyentes = new Set<() => void>()
let version = 0

/** Idempotente: la pila y las dos precargas pueden verla caer cada una por su lado. */
export function marcarRecorteCaido(url: string): void {
  if (url === '' || caidos.has(url)) return
  caidos.add(url)
  version += 1
  for (const oyente of oyentes) oyente()
}

/** Para fuera de un render; dentro de uno, `useRecorteVivo`. */
export function recorteCaido(url: string | null | undefined): boolean {
  return url !== null && url !== undefined && caidos.has(url)
}

function suscribir(oyente: () => void): () => void {
  oyentes.add(oyente)
  return () => {
    oyentes.delete(oyente)
  }
}

function leerVersion(): number {
  return version
}

/** Todo consumidor de `crop_download_url` pasa por acá: leer el campo crudo mostraría la imagen rota. */
export function useRecorteVivo(url: string | null | undefined): string | null {
  useSyncExternalStore(suscribir, leerVersion, leerVersion)
  return url !== null && url !== undefined && url !== '' && !caidos.has(url) ? url : null
}
